/**
 * Created by Ning Jiang on 11/24/2016.
 */

import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";

export class TombOfAkhenatenSoundConfig implements ISoundConfig {

    public static instance: TombOfAkhenatenSoundConfig = new TombOfAkhenatenSoundConfig();

    AS_WIN:string="asWin";
    AS_WIN_BIG:string="asWinBig";

    //sound effects
    BETWAY_SWEEP: string = "betlineSweep";
    BW_ENDS: string = "bigwinEnds";
    BW_INITIAL_WIN: string = "bigwinInitialWin";
    BW_LEVEL: string = "bigwinLevel";
    FS_CONTINUE_BTN: string = "continueButton";
    COUNT_UP_SOUND: string = "countup";
    FINAL_COUNT_SOUND: string = "countupEnds";
    FS_GAME_ENDS:string = "fsEnds";
    FS_FADE_OUTRO: string = "fsFadeToOutro";
    FS_INTRO:string = "fsIntro";
    FS_GAME_START:string = "fsStart";
    MULTIPLIER_COUNT_UP: string = "multiplierCountup";
    MULTIPLIER_COUNT_UP_ENDS: string = "multiplierCountupEnds";
    BIG_MULTIPLIER_SPAM: string = "multiplierDown";
    MULTIPLIER_UP: string = "multiplierUpgrade";
    PW_EXPLOSION: string = "pyramidExplosion";
    PW_EXPLOSION_SOFT: string = "pyramidExplosionSoft";
    PW_FIRE_ANTICIPATION: string = "pyramidFireAnticipation";
    PW_FIRE_SWEEP: string = "pyramidFireSweep";
    PW_LOCK: string = "pyramidLock";
    PW_SCALE_UP: string = "pyramidScaleUp";
    PW_SPINNING: string = "pyramidSpinning";
    PW_LANDING: string = "pyramidWildLanding";
    REELS_LANDING: string = "reelLanding";
    REELS_SPIN: string = "reelsSpinning";
    STONE_PRESS: string = "respinTopDown";
    ROPE_ROTATE: string = "ropeRotate1";
    SCATTER_LANDING: string = "scatter";
    SCATTER_ANTICIPATION_LOOP: string = "scatterAnticipation";
    SCATTER_ANTICIPATION_FAIL: string = "scatterAnticipationFail";
    SCATTER_HIGHLIGHT: string = "scatterHighlight";
    SCATTER_ADDITIONAL_SPIN: string = "scatterPlusSpin";
    NORMAL_WILD_LANDING: string = "wildLanding";
    EXTRA_WILD_LANDING: string = "wildRandom";
    WIN_SOUND: string = "win";

    //sound loops
    FS_BG_MUSIC_LOOP: string = "background-music-fs";
    MAIN_BG_MUSIC_LOOP_1: string = "background-music-main-loop1";
    MAIN_BG_MUSIC_LOOP_2: string = "background-music-main-loop2";
    MAIN_BG_MUSIC_LOOP_3: string = "background-music-main-loop3";

    //sound defaults
    REELS_DEFAULT_BOUNCE: string[] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5"];
    PW_START_SPIN: string = "pyramidStartSpin";
    PW_STOP_SPIN: string = "pyramidStopSpin";
    constructor() {
        if (TombOfAkhenatenSoundConfig.instance) {
            throw new Error("TombOfAkhenatenSoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}